export const fetchProductIds = (productIds: any, productList: any): any => {
  productList.map((product: any) => {
    const productRequest: any = {
      id: '',
      promoIds: []
    };
    const hom_promo = product?.products?.home_parent_promo_id;
    const mob_promo = product?.products?.mob_parent_promo_id;
    productRequest['id'] = product?.products?.product_id;
    if (hom_promo && !productRequest?.promoIds?.includes(hom_promo))
      productRequest.promoIds.push(hom_promo);
    if (mob_promo && !productRequest?.promoIds?.includes(mob_promo))
      productRequest.promoIds.push(mob_promo);
    productIds.push(productRequest);
  });
};

export const fetchPrice = (product: any, isMobileFlow: boolean, isConfigurator?: boolean): any => {
  const showPrice: any = {
    base: '',
    onetimePrice: '',
    discount: [],
    contractDuration: '',
    int_fmc: 0,
    mob_fmc: 0,
    mob_benefit_category: '',
    id: '',
    promoID: ''
  };
  Array.isArray(product) &&
    product?.map((item: any) => {
      showPrice['id'] = item?.id ?? '';
      item?.prices?.map((basePrice: any) => {
        if (basePrice?.priceType?.toLowerCase() === 'recurring')
          showPrice['base'] = basePrice?.value;
        else if (basePrice?.priceType?.toLowerCase() === 'one time')
          showPrice['onetimePrice'] = basePrice?.value;
      });
      item?.derivedPrice?.map((discountPrice: any) => {
        const cycle = { cycleStart: '', cycleEnd: '', value: '' };
        cycle['cycleStart'] = discountPrice?.cycle?.cycleStart;
        cycle['cycleEnd'] = discountPrice?.cycle?.cycleEnd;
        cycle['value'] = discountPrice?.value;
        showPrice['discount'].push(cycle);
      });
    });

  product?.[0]?.bundledOffers?.forEach((item: any) => {
    item?.prices?.forEach((productDetails: any) => {
      if (productDetails?.priceAlteration?.length > 0) {
        productDetails?.priceAlteration?.forEach((price: any) => {
          if (price?.priceCategory == 'INTERNET_FMC') {
            showPrice['int_fmc'] += Number(price?.value);
          } else if (price?.priceCategory == 'MULTIMOBILE' || price?.priceCategory == 'FMC') {
            showPrice['mob_fmc'] += Number(price?.value);
            showPrice['mob_benefit_category'] = price?.priceCategory;
          }
        });
      }
    });
    if (item?.promotionInfo?.[0]?.contractDuration) {
      showPrice['contractDuration'] = item?.promotionInfo?.[0]?.contractDuration;
    }
    if (item?.promotionInfo?.[0]?.id) {
      showPrice['promoID'] = item?.promotionInfo?.[0]?.id;
    }
  });
  if (!product?.[0]?.isBundle) {
    showPrice['contractDuration'] = product?.[0]?.promotionInfo?.[0].contractDuration;
    showPrice['promoID'] = product?.[0]?.promotionInfo?.[0]?.id;
  }
  let int_fmc = 0;
  product?.[0]?.prices?.map((productDetails: any) => {
    if (productDetails?.priceAlteration?.length > 0) {
      productDetails?.priceAlteration?.map((price: any) => {
        if (price?.priceCategory == 'INTERNET_FMC') {
          int_fmc += Number(price?.value);
        } else if (price?.priceCategory == 'MULTIMOBILE' || price?.priceCategory == 'FMC') {
          showPrice['mob_fmc'] += Number(price?.value);
          showPrice['mob_benefit_category'] = price?.priceCategory;
        }
      });
    }
  });
  if (!showPrice?.contractDuration && !isMobileFlow) {
    showPrice['contractDuration'] = '12';
  }
  {
    showPrice['int_fmc'] = isConfigurator ? int_fmc : showPrice['int_fmc'];
  }
  return showPrice;
};
